import { Button } from '~/components/general/Button'
import { trackEvent } from '~/utils/tracking'
import CareerAdviceAnimation from './Animation'
import { FlexContainer } from '~/components/Grid'
import { TypeAnimatedChatBlockSkeleton } from '~/types/contentful'
import { Entry } from 'contentful'
import { FC } from 'react'

type CareerAdviceProps = {
  section: Entry<TypeAnimatedChatBlockSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS', string>
}

export const CareerAdvice: FC<CareerAdviceProps> = ({ section }) => {
  const data = section.fields

  const handleCTABtnClick = () => {
    trackEvent('homepage_click_cta', {
      block: data.blockId,
      target: data.buttonLink as string,
      homepage_CTA: data.buttonName as string,
    })
  }

  return (
    <>
      <section
        className="my-25 -mx-8 max-xl:px-11 max-lg:my-15 max-lg:-mx-6 max-md:pt-11 max-md:px-4 max-md:pb-18 max-md:my-0 max-md:-mx-4"
        data-block-id={data.blockId}
      >
        {/* remove this flex. it is not needed */}
        <FlexContainer
          flexWrap={'nowrap'}
          className="max-lg:[&>img]:max-w-full max-lg:[&>video]:max-w-full max-lg:my-0 max-lg:mx-auto grid gap-5 grid-cols-2 max-md:flex max-md:flex-col-reverse"
        >
          {/* <DelayComponent
            fallback={
              <Skeleton>
                <DoubleBoxSkeleton />
              </Skeleton>
            }
          > */}
          <CareerAdviceAnimation data={data} />
          {/* </DelayComponent> */}
          <div className="flex flex-col items-start pt-15 max-w-[500px] max-xl:pl-5 max-lg:my-0 max-lg:mx-auto max-lg:mt-10 max-md:pt-2 max-md:pl-0">
            <h2 className="mb-8 max-md:mb-5 text-xl">{data.title}</h2>
            <p className="mb-10 max-xl:mb-9 max-md:mb-4 text-s">{data.description}</p>
            <Button
              text={data.buttonName}
              type={'link'}
              href={data.buttonLink}
              onClick={handleCTABtnClick}
              className={'w-fit'}
            />
          </div>
        </FlexContainer>
      </section>
    </>
  )
}
